import React from 'react'

import {FaAngleDoubleRight} from 'react-icons/fa'

import {store} from '../../stores/store'
import { observer } from 'mobx-react'
import { GAME_STATES } from '../../js/ids'
import PopupStore, { POPUPS_IDS } from '../../stores/PopupStore'



function BottomRightUI() {

  function handleClick() {
    if(store.isGameOver) {
      PopupStore.open(POPUPS_IDS.NEW_GAME_ALERT)
    } else {
      store.goToNextYear()
    }
  }

  return (
    <div className="bottom-right-ui">
      <div className="ui-button ui-button-right ui-button-bottom" onClick={handleClick}>
        <span className="label">
          {store.isGameOver ? store.t("restart") : store.t("next_year")}
        </span>

        <span className="icon"><FaAngleDoubleRight /></span>
      </div>
    </div>
  )
}

export default observer(BottomRightUI)
